export enum NotificationSettingsType {
    SlackToken = 1,
}
